<div class="content-block">
    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h2 class="content-block">Statistiche Articoli</h2>
            </div>
        </div>
    </div>
    <div class="card filtro-card">
        <div class="card-body">

            <div class="filtro-grid">

                <div class="campo">
                    <label>Articolo</label>
                    <dx-lookup [dataSource]="listArticoli" [searchEnabled]="true" [(value)]="idArticoloScelto"
                        valueExpr="id" [displayExpr]="displayArticoloExpr">
                    </dx-lookup>
                </div>

                <div class="campo">
                    <label>Da data</label>
                    <dx-date-box type="date" [(value)]="daData" displayFormat="dd/MM/yyyy">
                    </dx-date-box>
                </div>

                <div class="campo">
                    <label>A data</label>
                    <dx-date-box type="date" [(value)]="aData" displayFormat="dd/MM/yyyy">
                    </dx-date-box>
                </div>

                <div class="campo campo-bottone">
                    <dx-button stylingMode="contained" text="Cerca" icon="search" type="normal"
                        (onClick)="cercaConsegne()">
                    </dx-button>
                </div>

            </div>

        </div>
    </div>

    <div class="card">
        <div class="card-body">
            <dx-data-grid #dataGrid 
                [dataSource]="dataSource" 
                [height]="600" 
                [showBorders]="true"
                [focusedRowEnabled]="false" 
                [columnAutoWidth]="true" 
                [wordWrapEnabled]="true"
                [rowAlternationEnabled]="false" 
                [allowColumnResizing]="true" 
                [columns]="listColumns"
                [showColumnLines]="true" 
                [showRowLines]="true" 
                (onExporting)="onExporting($event)">

                <dxo-export [enabled]="true"></dxo-export>

                <dxo-paging [pageSize]="20">
                </dxo-paging>
                <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 20, 50, 100]">
                </dxo-pager>

                <dxo-filter-row [visible]="true" [applyFilter]="true"></dxo-filter-row>
                <dxo-scrolling mode="normal"></dxo-scrolling>


                <dxo-summary [totalItems]="totalSummaryItems"></dxo-summary>

                <div *dxTemplate="let d of 'giornoFasciaTemplate'" class="container-dati-giorno">
                    @if(d.value){
                    <i class="dx-icon-remove"></i>
                    }
                </div>

            </dx-data-grid>
        </div>
    </div>
</div>



<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel" [showIndicator]="true"
    [showPane]="true" [shading]="true" [hideOnOutsideClick]="false" message="Caricamento consegne">
</dx-load-panel>